import { render } from "./Documents.vue?vue&type=template&id=be09c4cc&scoped=true"
import script from "./Documents.vue?vue&type=script&lang=js"
export * from "./Documents.vue?vue&type=script&lang=js"

import "./Documents.vue?vue&type=style&index=0&id=be09c4cc&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be09c4cc"]])

export default __exports__